<template>
  <div>
    <section class="section is-title-bar">
      <div class="level">
        <div class="level-left">
          <div class="level-item">
            <p class="title is-5">Enquiries</p>
          </div>
        </div>
        <div class="level-right">
          <div class="level-item">
            <b-input placeholder="Search..." type="search" v-model="searchTerm" @input="customFilter(searchTerm)"></b-input>
          </div>
          <div class="level-item">
            <a class="button is-small is-link" @click="toggleFilterModal" title="Filter">
              <b-icon icon="filter" size="is-small"></b-icon>
            </a>
          </div>
        </div>
      </div>
      Total Records : <b>{{ total }}</b>
    </section>

    <section class="section is-main-section">
      <card-component title="" class="has-table">
        <b-table :paginated="true" :per-page="10" :striped="true" :hoverable="true" :data="filterData" style="overflow:auto">
          <template slot-scope="props">
            <b-table-column label="Lead Personal Info">
              <div class="tag is-primary">Parent Name : {{ props.row.fatherName || '-' }}</div>

              <div class="control">
                <span class="tag is-primary"> Parent Mobile : {{ props.row.fatherMobile || '-' }}</span>
              </div>

              <div class="control">
                <span class="tag is-primary">Student First Name: {{ props.row.studentFirstName }}</span>
              </div>
              <div class="control">
                <span class="tag is-primary"> Parent Email ID: {{ props.row.fatherEmailID }}</span>
              </div>
            </b-table-column>

            <b-table-column label="Opting Class" field="studentClass.name" sortable>
              {{ props.row.studentClass ? props.row.studentClass.name : '-' }}
            </b-table-column>
            <b-table-column label="Franchisee Name" field="franchisee.companyName" sortable>
              {{ props.row.franchisee ? props.row.franchisee.companyName : '-' }}
            </b-table-column>
            <b-table-column label="Enquiry Code" field="EnquiryCode" sortable>
              {{ props.row.enquiryCode }}
            </b-table-column>
            <b-table-column label="MCB Code" field="enquiryCodeMCB" sortable>
              {{ props.row.enquiryCodeMCB ? props.row.enquiryCodeMCB : '-' }}
            </b-table-column>
            <b-table-column label="Spanco Status">
              <b-field grouped group-multiline>
                <div class="control">
                  <span class="tag is-primary">Spanco: {{ (props.row.spanco && props.row.spanco.spanco) || '-' }}</span>
                </div>

                <div class="control">
                  <span class="tag is-primary">Spanco Status :{{ (props.row.spanco && props.row.spanco.spancoStatus) || '-' }}</span>
                </div>
                <div class="control">
                  <span class="tag is-primary"> Spanco Sub Status: {{ (props.row.spanco && props.row.spanco.spancoSubStatus) || '-' }}</span>
                </div>
              </b-field>
            </b-table-column>
            <b-table-column label="Dates">
              <div class="field is-grouped is-grouped-multiline">
                <div class="control">
                  <span class="tag is-primary">Created At: {{ props.row.createdAt }}</span>
                </div>

                <div class="control">
                  <span class="tag is-primary">Updated At :{{ props.row.updatedAt }}</span>
                </div>
              </div>
            </b-table-column>

            <b-table-column label="Action" custom-key="actions" class="is-actions-cell" width="140" centered v-if="isWrite">
              <div class="buttons">
                <router-link class="button is-info is-small btnicon" :to="{ name: 'EditSpanco', params: { enquiryID: props.row.id, enquiryCode: props.row.enquiryCode, radio: radio } }" title="Edit">
                  <b-icon icon="pencil" size="is-small" />
                </router-link>
              </div>
            </b-table-column>
          </template>
          <section class="section" slot="empty">
            <div class="content has-text-grey has-text-centered">
              <template v-if="isLoading">
                <p>
                  <b-icon icon="dots-horizontal" size="is-large" />
                </p>
                <p>Fetching data...</p>
              </template>
              <template v-else>
                <p>
                  <b-icon icon="emoticon-sad" size="is-large" />
                </p>
                <p>Nothing's here&hellip;</p>
              </template>
            </div>
          </section>
        </b-table>
      </card-component>
    </section>

    <!-- filter modal -->
    <div class="modal" :class="{ 'is-active': enableFilterModal }">
      <div class="modal-background"></div>
      <form class="modal-card" style="width:45rem;" @submit.prevent="getEnquiry">
        <header class="modal-card-head">
          <p class="modal-card-title"><strong> Enquiry Filter</strong></p>
          <button class="delete" type="button" @click="toggleFilterModal"></button>
        </header>
        <section class="modal-card-body">
          <div class="columns is-multiline">
            <div class="field column is-6">
              <label class="label">From <span class="has-text-danger">*</span></label>
              <div class="control">
                <input class="input" type="date" :max="filter.toDate" v-model="filter.fromDate" required />
              </div>
            </div>
            <div class="field column is-6">
              <label class="label">To <span class="has-text-danger">*</span></label>
              <div class="control">
                <input class="input" type="date" :max="maxToDate" v-model="filter.toDate" required />
              </div>
            </div>
            <div class="field column is-6">
              <label class="label">Spanco</label>
              <div class="control">
                <div class="select is-fullwidth">
                  <select name="spanco" v-model="filter.spanco">
                    <option disabled value>--Select--</option>
                    <option :value="key" v-for="(val, key) in spanco" :key="key"> {{ key }}</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="field column is-6">
              <label class="label">Spanco Status</label>
              <div class="control">
                <div class="select is-fullwidth">
                  <select v-model="filter.spancoStatus">
                    <option disabled value>---Select---</option>
                    <option :value="key" v-for="(val, key) in spanco[filter.spanco]" :key="key">{{ key }}</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="field column is-6">
              <label class="label">Academic year <span class="has-text-danger">*</span></label>
              <div class="control">
                <div class="select is-fullwidth">
                  <select v-model="filter.academicYearID" @change="getYearIn()">
                    <option value="">-select-</option>
                    <option v-for="year in academicYears" :key="year.id" :value="year.id"> {{ year.academicYear }}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <hr />
          <div class="columns form-row">
            <div class="column has-text-right">
              <button class="button is-success m-r-10" type="submit">Apply</button>
              <button class="button is-dark" type="button" @click="resetAll()">Reset</button>
            </div>
          </div>
        </section>
      </form>
    </div>
  </div>
</template>
<script>
import CardComponent from '@/components/template/CardComponent'
import constants from '@/utils/constants'
import moment from 'moment'
import Utils from '@/utils'
import _ from 'lodash'

export default {
  name: 'Spanco',
  props: ['radio2'],
  components: {
    CardComponent
  },
  data () {
    return {
      isWrite: false,
      filterData: [],
      searchTerm: '',
      radio: 'all',
      total: 0,
      isLoading: false,
      loadingComponent: null,
      enableFilterModal: false,
      enableSearchModal: false,
      enquiryData: [],
      filter: {
        fromDate: moment().format('YYYY-MM-DD'),
        toDate: moment().format('YYYY-MM-DD'),
        academicYearID: '',
        stage: 'All',
        spanco: '',
        spancoStatus: ''
      },
      maxToDate: moment().format('YYYY-MM-DD'),
      academicYears: [],
      stages: [],
      searchEnquiryObj: {
        academicYearID: '',
        searchType: 'studentmobile',
        searchKey: ''
      },
      spanco: {
        Suspect: {
          Yes: ['NA'],
          'Yet To Call': ['NA'],
          'Called But No Response': ['NA'],
          'Junk/Not Interested': [
            'Attempted thrice and no response',
            'Invalid Number',
            'Disconnected the call after introduction',
            'Age Eligibilty',
            'Admitted in Other School',
            'Filled by Mistake',
            'Not Interested',
            'Location/Distance Issue',
            'Others'
          ]
        },
        Prospect: {
          Cold: ['Interested-Call Back', 'Interested - Busy'],
          Warm: ['NA'],
          Hot: ['NA'],
          Dead: [
            'Admitted in other school',
            'Attempted thrice and no response',
            'Disconnected the call after introduction',
            'Not interested',
            'Online classes',
            'Enquired for Day care / after school activities',
            'Location / Transport issue',
            'Any other (Clear remarks to be mentioned in “Remarks” Column.'
          ]
        },
        Approach: {
          'Online Counselling Done': ['NA'],
          'Offline Counselling Done': ['NA'],
          'Appointments Fixed': ['NA'],
          'Appointment Pending': ['NA']
        },
        Negotiate: {
          'Application Fee Link Sent': ['NA'],
          'Need More Info': ['NA'],
          'Visit the Campus': ['NA'],
          'Need Demo': ['NA'],
          'Drop Off': ['Facilities', 'Fees/Concession', 'Online Classes', 'Application Fee Link Sent- No Response', 'Transport Facilities', 'Curriculum', 'Others'],
          'Decision Pending': ['NA']
        },
        Close: {
          'Admission Form Completed': ['NA'],
          'Tution Fee Paid': ['NA']
        },
        'On Board': {
          'Admission Confirmed': ['NA']
        }
      }
    }
  },
  async created () {
    this.isWrite = Utils.helper.getIsWriteFun(this.$route)

    try {
      this.loadingComponent = this.$buefy.loading.open()
      const { data: questions } = await http.get(`${constants.API_URL}/api/enquiry-questions`)
      this.stages = questions.filter(obj => obj.type === 'INTEREST_TYPE')
      const { data } = await http.get(`${constants.API_URL}/api/franchiseeAcademicYears`)
      this.academicYears = data.rows
      const currentAcademicYear = Utils.getCurrentAcademicYear()
      let academicYear = this.academicYears.find(y => {
        return y.academicYear.trim() === currentAcademicYear.trim()
      })
      this.filter.academicYearID = this.searchEnquiryObj.academicYearID = academicYear ? academicYear.id : ''
      this.loadingComponent.close()
      await this.getEnquiry()
      this.customFilter()
    } catch (e) {
      this.loadingComponent.close()
      const errorMessage = (e && e.response && e.response.data.message) || e.message
      console.log('errorMessage', errorMessage)
    }

    if (this.radio2) {
      this.radio = this.radio2
    }
  },
  computed: {},
  methods: {
    customFilter: function (searchTerm) {
      this.filterData = this.enquiryData
      if (_.isEmpty(searchTerm)) {
        this.filterData = this.enquiryData
      } else {
        let data = this.enquiryData
        if (this.radio === 'withMCBCode') {
          data = _.filter(data, 'enquiryCodeMCB')
        } else if (this.radio === 'withoutMCBCode') {
          data = _.filter(data, ['enquiryCodeMCB', null])
        }
        this.filterData = _.filter(
          data,
          item =>
            (item.fatherName && item.fatherName.toLowerCase().search(this.searchTerm.toLowerCase()) >= 0) ||
            (item.fatherMobile && item.fatherMobile.toLowerCase().search(this.searchTerm.toLowerCase()) >= 0) ||
            (item.franchiseeName && item.franchiseeName.toLowerCase().search(this.searchTerm.toLowerCase()) >= 0) ||
            (item.studentClass && item.studentClass.name && item.studentClass.name.toLowerCase().search(this.searchTerm.toLowerCase()) >= 0) ||
            (item.franchisee && item.franchisee.companyName.toLowerCase().search(this.searchTerm.toLowerCase()) >= 0) ||
            (item.enquiryCodeMCB && item.enquiryCodeMCB.toLowerCase().search(this.searchTerm.toLowerCase()) >= 0) ||
            (item.utmSource && item.utmSource.toLowerCase().search(this.searchTerm.toLowerCase()) >= 0)
        )
      }

      this.total = this.filterData.length
    },

    getEnquiry: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        const { data } = await http.get(`${constants.API_URL}/api/spanco`, {
          params: this.filter
        })
        this.enquiryData = data

        this.searchTerm = null
        this.customFilter()
        this.enquiryData.forEach(Enq => {
          Enq.createdAt = moment(Enq.createdAt).format('D-MMM-YYYY HH:mm')
          Enq.updatedAt = moment(Enq.updatedAt).format('D-MMM-YYYY HH:mm')
          Enq.studentName = Enq.studentFirstName
          if (Enq.studentMiddleName) {
            Enq.studentName = Enq.studentName + ' ' + Enq.studentMiddleName
          }
          if (Enq.studentLastName) {
            Enq.studentName = Enq.studentName + ' ' + Enq.studentLastName
          }
          if (Enq.enrollmentCode) {
            Enq.status = 'Admission'
          } else if (Enq.ApplicationCode) {
            Enq.status = 'Application'
          } else {
            Enq.status = 'Enquiry'
          }
        })
        if (this.radio === 'withMCBCode') {
          this.filterData = _.filter(this.filterData, 'enquiryCodeMCB')
        } else if (this.radio === 'withoutMCBCode') {
          this.filterData = _.filter(this.filterData, ['enquiryCodeMCB', null])
        }
        this.total = this.filterData.length
        this.loadingComponent.close()
        this.enableFilterModal = false
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    searchEnquiry: async function () {
      try {
        if (!this.searchEnquiryObj.academicYearID) {
          return this.$buefy.dialog.alert({
            type: 'is-danger',
            message: 'Please select academic year',
            hasIcon: true,
            animation: 'zoom-out',
            size: 'is-medium',

            icon: ' mdi-exclamation',
            iconPack: 'mdi',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
        }
        if (
          (this.searchEnquiryObj.searchType === 'studentname' && this.searchEnquiryObj.searchKey.length < 3) ||
          (this.searchEnquiryObj.searchType === 'studentmobile' && this.searchEnquiryObj.searchKey.length < 5)
        ) {
          return
        }
        // const { data } = await http.get(`${constants.API_URL}/api/search-enquiry/`, {
        //   params: this.searchEnquiryObj
        // })
        // console.log('data---', data)
        this.$router.push({ name: 'enquiryForm' })
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('error while searching enquiry data : ', errorMessage)
      }
    },
    toggleFilterModal: function () {
      this.enableFilterModal = !this.enableFilterModal
    },
    toggleSearchModal: function () {
      this.enableSearchModal = !this.enableSearchModal
    },
    getYearIn: function () {
      this.academicYears.find(obj => {
        if (obj.id === this.filter.academicYearID) {
          this.Year = Number(obj.academicYear.split('-')[0])
        }
      })
      let currentMonth = new Date().getMonth()
      let currentDate = new Date().getDate()

      this.filter.fromDate = moment(`${currentMonth}/${currentDate}/${this.Year}`).format('YYYY-MM-DD')
      this.filter.toDate = moment(`${currentMonth}/${currentDate}/${this.Year + 1}`).format('YYYY-MM-DD')
    },
    resetAll: function () {
      const currentAcademicYear = Utils.getCurrentAcademicYear()
      let academicYear = this.academicYears.find(y => {
        return y.academicYear.trim() === currentAcademicYear.trim()
      })
      this.filter = {
        fromDate: moment().format('YYYY-MM-DD'),
        toDate: moment().format('YYYY-MM-DD'),
        academicYearID: (this.searchEnquiryObj.academicYearID = academicYear ? academicYear.id : ''),
        stage: 'All',
        spanco: '',
        spancoStatus: ''
      }
      this.getEnquiry()
    },
    inputIsNumber: function () {
      if (this.searchEnquiryObj.searchType === 'studentmobile') {
        Utils.isNumber()
      }
    }
  }
}
</script>
